<template>
  <div style="text-align: left;">
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/negocio-orcamentos' }">Orçamentos de Negócios</el-breadcrumb-item>
          <el-breadcrumb-item>Divisão</el-breadcrumb-item>
          <el-breadcrumb-item>Atividade</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" :gutter="10" style="text-align: center;">
      <el-col :span="24">
        <h1>Orçamento da Atividade da Divisão do Negócio</h1>
      </el-col>
    </el-row>

    <el-row type="flex" justify="left" :gutter="10" style="">
      <el-col :span="24">
        <el-button type="primary" icon="el-icon-back" @click="$router.go(-1)">Voltar</el-button>
      </el-col>
      <el-col :span="24" style="height: 10px; text-align:right;">
        <el-button
          class="details-icon-button"
          type="primary"
          icon="el-icon-refresh"
          v-if="permissao.editar_painel"
          @click="negocioRevisaoDivisaoRecalcular()"> Recalcular Esta Atividade da Divisão do Negócio
        </el-button>
        <br/>
<!--         
        <el-button
          class="details-icon-button"
          type="primary"
          icon="el-icon-refresh"
          @click="enviarCotacao()"> Enviar Cotação
        </el-button>
         -->
      </el-col>
    </el-row>

    <br />
    <div style="height: auto;" class="details-content">
        <table>
          <tr>
            <td><strong>Obra:</strong></td><td style="width: 550px;"> {{divisao.cliente.cliente_cod}} - {{divisao.cliente.nome_fantasia}}</td>
            <td> <strong>Valor da Revisão:</strong></td><td><strong> R$ {{formatarValor(divisao.negocio.valor_total, 2)}}</strong></td>
          </tr>
          <tr>
            <td><strong>Cidade:</strong></td><td> {{divisao.cliente.municipio}} - {{divisao.cliente.uf}} - {{divisao.cliente.pais}}</td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Negócio:</strong></td><td> {{divisao.negocio.negocio_numero}} &nbsp;&nbsp;&nbsp; <b>Versão:</b> {{divisao.negocio.negocio_versao}} &nbsp;&nbsp;&nbsp; <b>Revisão:</b> {{divisao.negocio.negocio_revisao}}</td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Divisão:</strong></td><td> {{divisao.negocio.negocio_divisao}} - {{divisao.negocio.negocio_divisao_nome}}</td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Atividade:</strong></td><td> {{divisao.negocio.negocio_atividade}} - {{divisao.negocio.negocio_atividade_nome}}</td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Sequência:</strong></td><td> {{divisao.negocio.negocio_sequencia}} - {{divisao.negocio.titulo}}</td>
            <td></td>
          </tr>
        </table>
    </div>

    <el-row type="flex" justify="left" :gutter="10">
      <el-tabs v-model="activeTab" type="card" @tab-click="aoClicarNaAba" style="width: 100%;">
        <el-tab-pane label="Principal" name="principal" v-if="exibirAbaGeral">
            <div v-if="carregandoNegocio" class="text-center">
              <p><i class="el-icon-loading"></i> Carregando negócio...</p>
            </div>
            <div v-else-if="!divisao.negocio">
              <p><i class="el-icon-warning"></i> Nenhum dado de negócio encontrado.</p>
            </div>
            <div v-else>
              <p><strong>Detalhes Gerais:</strong></p>
              <table>
                <tr>
                  <td colspan="2">&nbsp;</td>
                  <td class = "outros" style="width: 150px !important;">Total</td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Total da NBRtec:</strong></td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.negocio.valor_total_nbrtec, 2)}}</strong></td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Total do Faturamento do Direto:</strong></td>
                  <td class = "outros"><strong>R$ {{formatarValor(divisao.negocio.total_faturamento_direto, 2)}}</strong></td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Total da Atividade da Divisão:</strong></td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.negocio.valor_total_geral, 2)}}</strong></td>
                </tr>
                <tr>
                  <td colspan="3"><br/></td>
                </tr>
                <tr>
                  <td colspan="2"><strong>IBS:</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(ibs, 2)}}</td>
                </tr>
                <tr>
                  <td colspan="2"><strong>CBS:</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(cbs, 2)}}</td>
                </tr>
                <tr>
                  <td colspan="2"><strong>IPI:</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(ipi, 2)}}</td>
                </tr>
              </table>
            </div>
        </el-tab-pane>

        <el-tab-pane label="Formação" name="formacao" v-if="exibirAbaFormacao">
            <div v-if="carregandoNegocio" class="text-center">
              <p><i class="el-icon-loading"></i> Carregando negócio...</p>
            </div>
            <div v-else-if="!divisao.negocio">
              <p><i class="el-icon-warning"></i> Nenhum dado de negócio encontrado.</p>
            </div>
            <div v-else>
              <p><strong>Detalhes da Formação de Preço:</strong></p>
              <table>
                <tr>
                  <td>&nbsp;</td>
                  <td class = "outros" style="width: 150px !important;">Percentual</td>
                  <td class = "outros" style="width: 150px !important;">Total</td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Total de Matéria Prima:</strong></td>
                  <!-- <td class="alinha-direita">R$ {{formatarValor(divisao.negocio.total_mp, 2)}}</td> -->
                  <!-- <td class = "outros"><input class = "outros" style = "background-color:yellow;" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.total_mp" v-money="moneyConfig"/></td> -->
                  <td class = "outros"><input class = "outros" style = "background-color:yellow;" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.total_mp"/></td>
                   <!-- <div>{{ divisao.negocio.total_mp }}</div> -->
                  <!-- <td class="alinha-direita">R$ {{formatarValor(divisao.negocio.total_mp_provisorio, 2)}}</td> -->
                </tr>
                <tr>
                  <td colspan="2"><strong>Total de Mão de Obra 1:</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(divisao.negocio.total_mo, 2)}}</td>
                  <!-- <td class = "outros"><input class = "outros" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.total_mo"/></td> -->
                </tr>
                <tr>
                  <td><strong>Total de Mão de Obra 2:</strong></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.negocio.perc_mo_2"/>%</td>
                  <td class="alinha-direita">R$ {{formatarValor(divisao.negocio.total_mo_2, 2)}}</td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Total do Frete:</strong></td>
                  <td class = "outros"><input class = "outros" style = "background-color:red;" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.valor_frete" disabled/></td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Total de Despesas:</strong></td>
                  <td class = "outros"><input class = "outros"  style = "background-color:red;" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.valor_despesas" disabled/></td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Total de Outros:</strong></td>
                  <td class = "outros"><input class = "outros" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.valor_outros"/></td>
                </tr>
<!-- 
                <tr>
                  <td colspan="2"><strong>Sem IPI:</strong></td>
                  <td class="outros">
                    <select 
                      v-model="divisao.negocio.sem_ipi"
                      class=""
                    >
                      <option value="S">Sim</option>
                      <option value="N">Não</option>
                    </select>
                  </td>
                </tr>
 -->
                <tr>
                  <td colspan="2"><strong>Total do CMV:</strong></td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(cmv, 2)}}</strong></td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Total da NBRtec:</strong></td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.negocio.valor_total_nbrtec, 2)}}</strong></td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                </tr>
                <tr>
                  <td><strong>Total do Faturamento do Direto:</strong></td>
                  <td class = "outros"><input class = "outros" style = "background-color:yellow;" type="text" placeholder="R$ 0.00" v-model="divisao.negocio.valor_faturamento_direto"/></td>
                  <td class = "outros"><strong>R$ {{formatarValor(divisao.negocio.total_faturamento_direto, 2)}}</strong></td>
                  <!-- <td class="alinha-direita">R$ {{formatarValor(divisao.negocio.valor_faturamento_direto_provisorio, 2)}}</td> -->
                </tr>
                <tr>
                  <td colspan="2"><strong>Total da Atividade da Divisão:</strong></td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.negocio.valor_total_geral, 2)}}</strong></td>
                </tr>
              </table>
            </div>
            <br/>
            <el-tooltip
              v-if="permissao.editar_painel"
              class="item"
              effect="light"
              content="Alterar Dados"
              placement="top"
            >
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                @click="negocioRevisaoDivisaoPrincipalAlterar()"> Alterar Dados da Formação da Atividade da Divisão do Negócio
              </el-button>
            </el-tooltip>
        </el-tab-pane>

        <el-tab-pane label="Matéria Prima" name="detalhes" v-if="exibirAbaMateriaPrima">
          <div v-if="carregandoDetalhe" class="text-center">
            <p><i class="el-icon-loading"></i> Carregando detalhes...</p>
          </div>
          <div v-else-if="!divisao.itens">
            <p><i class="el-icon-warning"></i> Nenhum dado de detalhe encontrado.</p>
          </div>
          <div v-else >
            <div class="table-controls">
              <el-input
                v-model="search"
                size="small"
                placeholder="Filtrar por Descrição..."
                clearable
                class="filter-input">
              </el-input>
              <el-button type="primary" size="small" @click="expandAll">Expandir Todos</el-button>
              <el-button type="primary" size="small" @click="collapseAll">Recolher Todos</el-button>
              <el-button type="primary" size="small" @click="showFormFiltrarItens()">Filtrar Por Fabricante</el-button>
              <el-tooltip
                v-if="permissao.editar_painel"
                class="item"
                effect="light"
                style = "margin-left: 10px;"
                content="Alterar Dados dos Itens da Matéria Prima da Atividade da Atividade da Divisão do Negócio"
                placement="top"
              >
                <el-button
                  class="details-icon-button"
                  size="small"
                  type="warning"
                  icon="el-icon-refresh"
                  @click="alterarItemDivisaoNegocio()"> Alterar
                </el-button>
              </el-tooltip>
              <span style="margin-left: 20px;">SemFD: <strong>R$ {{ formatarValor(this.divisao.itens.atividade_total_mp_sfd, 2) }}</strong></span>
              <span style="margin-left: 20px;">ComFD: <strong>R$ {{ formatarValor(this.divisao.itens.atividade_total_mp_cfd , 2)}}</strong></span>
              <span style="margin-left: 20px;">Total: <strong>R$ {{ formatarValor(this.divisao.itens.atividade_total_mp_sfd + this.divisao.itens.atividade_total_mp_cfd , 2)}}</strong></span>
            </div>
            <el-table
              :key="tableKey"
              ref="treeTable"
              :data="dadosTabela"
              height="calc(100vh - 300px)"
              style="width: 100%;"
              row-key="filho"
              border
              :tree-props="{children: 'filhos'}"
              :row-class-name="setRowClassName"
              @sort-change="aoMudarOrdenacao">
              <el-table-column
                class-name="tree-column-codigo"
                prop="codigo"
                label="Código"
                sortable="custom"
                width="160">
              </el-table-column>
              <el-table-column
                prop="descricao"
                label="Descrição"
                sortable
                min-width="380">
              </el-table-column>
              <el-table-column
                prop="qtde_material_inicial"
                label="Qtde Inicial MP"
                sortable="custom"
                align="right" 
                header-align="right"
                width="150"
              >
                <template v-slot="{row}">
                  {{formatarValor(row.qtde_material_inicial, 4)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="qtde_material_total"
                label="Qtde Total MP"
                sortable="custom"
                align="right" 
                header-align="right"
                width="140"
              >
                <template v-slot="{row}">
                  {{formatarValor(row.qtde_material_total, 4)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="um"
                label="Und"
                width="55">
              </el-table-column>
              <el-table-column
                prop="valor_material"
                label="Unitário MP"
                sortable="custom"
                align="right" 
                header-align="right"
                width="130"
              >
                <template v-slot="{row}">
                  {{formatarValor(row.valor_material, 4)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="fator_mp"
                label="Fator MP"
                sortable="custom"
                align="right" 
                header-align="right"
                width="105"
              >
                <template v-slot="{row}">
                  {{formatarValor(row.fator_mp, 4)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="valor_material_total"
                label="Total MP"
                sortable="custom"
                align="right" 
                header-align="right"
                width="130"
              >
                <template v-slot="{row}">
                  {{formatarValor(row.valor_material_total, 2)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="qtde_mao_obra"
                label="Qtde MO"
                sortable="custom"
                align="right" 
                header-align="right"
                width="130"
              >
                <template v-slot="{row}">
                  {{formatarValor(row.qtde_mao_obra, 4)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="valor_mo_total"
                label="Total MO"
                sortable="custom"
                align="right" 
                header-align="right"
                width="130"
              >
                <template v-slot="{row}">
                  {{formatarValor(row.valor_mo_total, 2)}}
                </template>
              </el-table-column>
              <el-table-column
                label="Ações"
                width="70"
                align="center">
                <template slot-scope="scope">
                  <!-- v-if="permissao.editaritem_painel && scope.row.kit === 'N' && scope.row.faturamento_direto === 'N'" -->
                  <el-tooltip 
                    v-if="permissao.editaritem_painel && scope.row.kit === 'N'"
                    class="item" 
                    effect="light" 
                    content="Alterar Item da Atividade da Divisão" 
                    placement="top"
                  >
                    <el-button
                      class="details-icon-button"
                      size="mini"
                      type="primary"
                      icon="el-icon-document"
                      @click="showFormItemMP(scope.row)"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Mão de Obra" name="maoobra" v-if="exibirAbaMaoObra">
            <div v-if="carregandoMaoObra" class="text-center">
              <p><i class="el-icon-loading"></i> Carregando mão de obra...</p>
            </div>
            <div v-else-if="!divisao.mao_obra">
              <p><i class="el-icon-warning"></i> Nenhum dado de mão de obra encontrado.</p>
            </div>
            <div v-else>
              <p><strong>Detalhes da Mão de Obra:</strong></p>
              <table>
                <tr>
                  <td>&nbsp;</td>
                  <td class = "alinha-direita">Horas</td>
                  <!-- <td class = "alinha-direita">Valor</td> -->
                  <td class = "alinha-direita">Total</td>
                </tr>
                <tr v-for="item in divisao.mao_obra" :key="item.codigo">
                  <td><strong>{{ item.descricao }}:</strong></td>
                  <td><input class = "qtde-horas" type="text" placeholder="0 horas" :value="item.qtde_hora" @input="item.qtde_hora = $event.target.value.replace(',', '.')"/></td>
                  <!-- <td><input class = "valor-hora" type="text" placeholder="R$ 0,00" :value="item.valor_hora" @input="item.valor_hora = $event.target.value.replace(',', '.')"/></td> -->
                  <td class="alinha-direita"> R$ {{formatarValor(item.valor_total, 2)}} </td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Total:</strong></td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.mao_obra_total, 2)}}</strong></td>
                </tr>
              </table>
              <br/>
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="negocioRevisaoDivisaoMaoObraAlterar()"> Alterar Dados da Mão de Obra da Atividade da Divisão do Negócio
              </el-button>
              <br/>
            </div>
        </el-tab-pane>

        <el-tab-pane label="Impostos" name="impostos" v-if="exibirAbaImposto">
            <div v-if="carregandoImposto" class="text-center">
              <p><i class="el-icon-loading"></i> Carregando impostos...</p>
            </div>
            <div v-else-if="!divisao.imposto">
              <p><i class="el-icon-warning"></i> Nenhum dado de imposto encontrado.</p>
            </div>
            <div v-else>
              <p><strong>Detalhes dos Impostos:</strong></p>
              <table style="min-width: 350px;max-width: 650px;">
                <tr>
                  <td colspan="4"><strong>Detalhes dos Tributos sobre a Venda:</strong></td>
                </tr>
                <tr>
                  <td><strong>ICMS:</strong></td>
                  <td class="alinha-direita">{{formatarValor(divisao.imposto.icms_percentual, 2)}}%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.icms_valor, 2)}}</strong></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
                <tr>
                  <td><strong>PIS:</strong></td>
                  <td class="alinha-direita">{{formatarValor(divisao.imposto.pis_percentual, 2)}}%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.pis_valor, 2)}}</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>COFINS:</strong></td>
                  <td class="alinha-direita">{{formatarValor(divisao.imposto.cofins_percentual, 2)}}%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.cofins_valor, 2)}}</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="4">&nbsp;</td>
                </tr>
                <tr>
                  <td><strong>NCM:</strong></td>
                  <td colspan="1" style="text-align: right;">
                    {{divisao.imposto.ncm_numero}}
                  </td>
                  <td></td>
                </tr>
<!-- 
                <tr>
                  <td colspan="4" class = "" style="color: red;"><i>{{divisao.imposto.ncm_descricao}}</i></td>
                </tr>
 -->
                <tr>
                  <td colspan="4">&nbsp;</td>
                </tr>
                <tr>
                  <td><strong>IPI:</strong></td>
                  <td class="alinha-direita">{{formatarValor(divisao.imposto.ipi_percentual, 2)}}%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.ipi_valor, 2)}}</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="4">&nbsp;</td>
                </tr>
                <tr>
                  <td colspan="4"><strong>Detalhes do Destaque dos Impostos Futuros:</strong></td>
                </tr>
                <tr>
                  <td><strong>IBS:</strong></td>
                  <td class="alinha-direita">{{formatarValor(divisao.imposto.ibs_percentual, 2)}}%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.ibs_valor, 2)}}</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>CBS:</strong></td>
                  <td class="alinha-direita">{{formatarValor(divisao.imposto.cbs_percentual, 2)}}%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.cbs_valor, 2)}}</strong></td>
                  <td></td>
                </tr>
<!-- 
                <tr>
                  <td colspan="4"><i>{{divisao.imposto.ncm_observacao}}</i></td>
                </tr>
-->
                <tr>
                  <td colspan="4">&nbsp;</td>
                </tr>
                <tr>
                  <td colspan="4"><strong>Detalhes dos Tributos sobre Lucro:</strong></td>
                </tr>
                <tr>
                  <td><strong>CSLL:</strong></td>
                  <td class="alinha-direita">{{formatarValor(divisao.imposto.csll_percentual, 2)}}%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.csll_valor, 2)}}</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>IRRF:</strong></td>
                  <td class="alinha-direita">{{formatarValor(divisao.imposto.irpj_percentual, 2)}}%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.irpj_valor, 2)}}</strong></td>
                  <td></td>
                </tr>
              </table>
<!-- 
              <br/>
              <el-button 
                class="details-icon-button"
                size="small"
                icon="el-icon-refresh"
                type="warning"
                :loading="loading"
                v-if="permissao.editar_painel"
                @click="negocioRevisaoDivisaoImpostoAlterar()"
              >
                Alterar Dados do Imposto da Atividade da Divisão do Negócio
              </el-button>

              <br/>
 -->
            </div>
        </el-tab-pane>

        <el-tab-pane label="Comissões" name="comissoes" v-if="exibirAbaComissao">
            <div v-if="carregandoComissao" class="text-center">
              <p><i class="el-icon-loading"></i> Carregando comissão...</p>
            </div>
            <div v-else-if="!divisao.comissao">
              <p><i class="el-icon-warning"></i> Nenhum dado de comissão encontrado.</p>
            </div>
            <div v-else>
              <p><strong>Detalhes das Comissões:</strong></p>
              <table style="min-width: 350px;max-width: 650px;">
                <tr>
                  <td>&nbsp;</td>
                  <td class = "alinha-direita">Fator</td>
                  <td class = "alinha-direita">Percentual</td>
                  <td class = "alinha-direita">Total</td>
                  <td class = "alinha-direita">Encargo</td>
                </tr>
                <tr>
                  <td><strong>Comissão Gerente:</strong></td>
                  <td class = "outros"><input class = "fator" type="text" placeholder="0,0000" v-model="divisao.comissao.fator_comissao_gerente"/></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.comissao.comissao_gerente_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.comissao_gerente_valor, 2)}}</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(divisao.comissao.comissao_gerente_encargos_valor, 2)}}</td>
                </tr>
                <tr>
                  <td><strong>Comissão Interna:</strong></td>
                  <td class = "outros"><input class = "fator" type="text" placeholder="0,0000" v-model="divisao.comissao.fator_comissao_interna"/></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.comissao.comissao_interna_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.comissao_interna_valor, 2)}}</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(divisao.comissao.comissao_interna_encargos_valor, 2)}}</td>
                </tr>
                <tr>
                  <td><strong>Comissão Externa:</strong></td>
                  <td class = "outros"><input class = "fator" type="text" placeholder="0,0000" v-model="divisao.comissao.fator_comissao_externa"/></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.comissao.comissao_externa_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.comissao_externa_valor, 2)}}</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(divisao.comissao.comissao_externa_encargos_valor, 2)}}</td>
                </tr>
                <tr>
                  <td><strong>Indicador Externo:</strong></td>
                  <td class = "outros"><input class = "fator" type="text" placeholder="0,0000" v-model="divisao.comissao.fator_indicador_externo"/></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.comissao.indicador_externo_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.indicador_externo_valor, 2)}}</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(divisao.comissao.indicador_externo_encargos_valor, 2)}}</td>
                </tr>
                <tr>
                  <td colspan="3"><strong>Total:</strong></td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.comissao_total, 2)}}</strong></td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.comissao_encargos_total, 2)}}</strong></td>
                </tr>
              </table>
              <br/>
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="negocioRevisaoDivisaoComissaoAlterar()"> Alterar Dados da Comissão da Atividade da Divisão do Negócio
              </el-button>
              <br/>
            </div>
        </el-tab-pane>

        <el-tab-pane label="Desconto" name="desconto" v-if="exibirAbaDesconto">
            <div v-if="carregandoDesconto" class="text-center">
              <p><i class="el-icon-loading"></i> Carregando desconto ...</p>
            </div>
            <div v-else-if="!divisao.margem">
              <p><i class="el-icon-warning"></i> Nenhum dado de desconto encontrado.</p>
            </div>
            <div v-else>
              <p><strong>Detalhes do Desconto:</strong></p>
              <table style="min-width: 350px;max-width: 650px;">
                <tr v-if="permissao.descontorepresentante_painel">
                  <td colspan="2"><strong>Desconto Representante:</strong></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.margem.desconto_representante_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.margem.desconto_representante_valor, 2)}}</strong></td>
                </tr>
                <tr v-if="permissao.descontoadministrador_painel">
                  <td colspan="2"><strong>Desconto Administrador:</strong></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.margem.desconto_administrador_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.margem.desconto_administrador_valor, 2)}}</strong></td>
                </tr>
              </table>
              <br/>
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="negocioRevisaoDivisaoMargemAlterar()"> Alterar Dados da Margem da Atividade da Divisão do Negócio
              </el-button>
              <br/>
            </div>
        </el-tab-pane>

        <el-tab-pane label="Markups" name="markups" v-if="exibirAbaMarkup">
            <div v-if="carregandoMarkup" class="text-center">
              <p><i class="el-icon-loading"></i> Carregando markup...</p>
            </div>
            <div v-else-if="!divisao.markup">
              <p><i class="el-icon-warning"></i> Nenhum dado de markup encontrado.</p>
            </div>
            <div v-else>
              <p><strong>Detalhes dos Markups:</strong></p>
              <table>
                <tr>
                  <td>&nbsp;</td>
                  <td class = "alinha-direita">Percentual</td>
                  <td class = "alinha-direita">Total</td>
                </tr>
                <tr>
                  <td><strong>Despesas Administrativas:</strong></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.markup.despesas_administrativas_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.markup.despesas_administrativas_valor, 2)}}</strong></td>
                </tr>
                <tr>
                  <td><strong>Custo Indireto:</strong></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.markup.custo_indireto_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.markup.custo_indireto_valor, 2)}}</strong></td>
                </tr>
                <tr>
                  <td><strong>Gastos Gerais Fabricação:</strong></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.markup.gastos_gerais_fabricacao_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.markup.gastos_gerais_fabricacao_valor, 2)}}</strong></td>
                </tr>
                <tr>
                  <td><strong>Margem Faturamento Direto:</strong></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.markup.margem_faturamento_direto"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.markup.faturamento_direto_valor, 2)}}</strong></td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Total:</strong></td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.markup.markup_total, 2)}}</strong></td>
                </tr>
              </table>
              <br/>
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="negocioRevisaoDivisaoMarkupAlterar()"> Alterar Dados do Markup da Atividade da Divisão do Negócio
              </el-button>
              <br/>
            </div>
        </el-tab-pane>

        <el-tab-pane label="Margens" name="margens" v-if="exibirAbaMargem">
            <div v-if="carregandoMargem" class="text-center">
              <p><i class="el-icon-loading"></i> Carregando margem ...</p>
            </div>
            <div v-else-if="!divisao.margem">
              <p><i class="el-icon-warning"></i> Nenhum dado de margem encontrado.</p>
            </div>
            <div v-else>
              <p><strong>Detalhes das Margens:</strong></p>
              <table>
                <tr>
                  <td>&nbsp;</td>
                  <td class = "alinha-direita">Fator</td>
                  <td class = "alinha-direita">Percentual</td>
                  <td class = "alinha-direita">Total</td>
                </tr>
                <tr>
                  <td><strong>Lucro 1:</strong></td>
                  <td class = "outros"><input class = "fator" type="text" placeholder="0,0000" v-model="divisao.margem.lucro_fator"/></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.margem.lucro_percentual"/>%</td>
                  <td class="alinha-direita">R$ {{formatarValor(divisao.margem.lucro_valor_1, 2)}}</td>
                </tr>
                <tr>
                  <td colspan="3"><strong>Lucro 2:</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(divisao.margem.lucro_valor_2, 2)}}</td>
                </tr>
                <tr>
                  <td colspan="3"><strong>CSLL:</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(divisao.margem.csll_valor, 2)}}</td>
                </tr>
                <tr>
                  <td colspan="3"><strong>IRPJ:</strong></td>
                  <td class="alinha-direita">R$ {{formatarValor(divisao.margem.irpj_valor, 2)}}</td>
                </tr>
                <tr>
                  <td><strong>Lucro Líquido:</strong></td>
                  <td>&nbsp;</td>
                  <td class="alinha-direita"><span style = "color:red;">{{formatarValor(divisao.margem.lucro_liquido_percentual, 2)}}%</span></td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.margem.lucro_liquido_valor, 2)}}</strong></td>
                </tr>
                <tr v-if="permissao.descontorepresentante_painel">
                  <td colspan="2"><strong>Desconto Representante:</strong></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.margem.desconto_representante_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.margem.desconto_representante_valor, 2)}}</strong></td>
                </tr>
                <tr v-if="permissao.descontoadministrador_painel">
                  <td colspan="2"><strong>Desconto Administrador:</strong></td>
                  <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.margem.desconto_administrador_percentual"/>%</td>
                  <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.margem.desconto_administrador_valor, 2)}}</strong></td>
                </tr>
              </table>
              <br/>
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="negocioRevisaoDivisaoMargemAlterar()"> Alterar Dados da Margem da Atividade da Divisão do Negócio
              </el-button>
              <br/>
            </div>
        </el-tab-pane>

        <el-tab-pane label="Observações" name="observacoes" v-if="exibirAbaObservacao">
            <div>
              <p><strong>Observação Interna (Não Aparece na Proposta):</strong></p>
              <textarea 
                rows="8" 
                cols="80" 
                placeholder="Digite aqui suas observações internas..."
                v-model="divisao.negocio.observacao_interna"
              >
              </textarea>
              <br/>
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="negocioRevisaoDivisaoPrincipalAlterar()"> Alterar Dados da Observação da Atividade da Divisão do Negócio
              </el-button>
              <br/>
            </div>
        </el-tab-pane>

      </el-tabs>
    </el-row>

    <el-dialog
      title="Detalhes do Item"
      :visible.sync="formItemMPVisible"
      :close-on-click-modal="false"
      :before-close="closeFormItemMP"
      width="600px"
    >
      
      <el-form 
        ref="formFator" 
        :model="selectedRow" 
        label-width="120px" 
        size="small"
      >
        
        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Código">
              <el-input class="input-disabled" v-model="selectedRow.codigo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Descrição">
          <el-input class="input-disabled" v-model="selectedRow.descricao" disabled type="textarea" :rows="3"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Qtde Inicial MP">
              <el-input class="input-disabled direita" :value="formatarValor(selectedRow.qtde_material_inicial, 4)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Qtde Total MP">
              <el-input class="input-disabled direita" :value="formatarValor(selectedRow.qtde_material_total, 4)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Und MP">
              <el-input class="input-disabled" v-model="selectedRow.um" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Unitário MP">
              <el-input class="input-disabled direita" :value="formatarValor(selectedRow.valor_material, 4)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <!-- Campo editável: Fator -->
            <el-form-item label="Fator MP" prop="fator">
                <el-input-number
                  class="direita"
                  v-model="selectedRow.fator_mp"
                  :precision="4"
                  :step="0.0001"
                  :min="0"
                  controls-position="right"
                  style="width: 100%">
                </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Total MP">
              <el-input class="input-disabled direita" :value="formatarValor(selectedRow.valor_material_total, 2)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Qtde MO">
              <el-input class="input-disabled direita" :value="formatarValor(selectedRow.qtde_mao_obra, 4)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Total MO">
              <el-input class="input-disabled direita" :value="formatarValor(selectedRow.valor_mo_total, 2)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

<!-- 
        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Valor atual">
              <span>{{ selectedRow.valor_material_total }}</span>
            </el-form-item>
          </el-col>
        </el-row>
 -->

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeFormItemMP">Cancelar</el-button>
        <el-button type="primary" @click="salvarFator">Salvar Alteração</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Itens da Atividade da Divisão do Negócio"
      :visible.sync=" formFiltrarItensVisible"
      width="1200px"
      :close-on-click-modal="false"
      :before-close="closeFormFiltrarItens">
      
      <el-form 
        ref="formFiltrarItens" 
        :model="selectedRow" 
        label-width="80px" 
        size="small">
        
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Filtrar por">
              <el-select
                v-model="filtro.tipo"
                placeholder="Selecione o tipo de filtro"
                clearable
                @change="aoMudarTipoFiltro"
                style="width: 100%">
                <el-option label="Fabricante" value="fabricante"></el-option>
                <el-option label="Grupo" value="grupo"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item :label="labelSegundoSelect">
                <el-select
                  v-model="filtro.valor"
                  :placeholder="placeholderSegundoSelect"
                  filterable
                  clearable
                  :loading="carregandoOpcoes"
                  @change="aplicarFiltro"
                  style="width: 100%">
                  <el-option
                    v-for="item in opcoesFiltro"
                    :key="item.codigo"
                    :label="item.nome"
                    :value="item.codigo">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="5" style="display: flex; align-items: flex-end;">
            <el-button type="primary" @click="aplicarFiltro" icon="el-icon-search">
              Aplicar
            </el-button>
            <el-button @click="limparFiltro" icon="el-icon-refresh-right">
              Limpar
            </el-button>
          </el-col>
        </el-row>

        <el-table
          ref="itensAgrupadosTable"
          :data="itensFiltrados"
          height="calc(60vh - 200px)"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >

          <el-table-column
            type="selection"
            width="55"
            align="center">
          </el-table-column>

          <el-table-column
            prop="codigo"
            label="Código"
            sortable  
            width="93">
          </el-table-column>
          <el-table-column
            prop="descricao"
            label="Descrição"
            sortable  
            width="500">
          </el-table-column>

          <el-table-column
            prop="qtde_material_total"
            label="Qtde MP"
            sortable
            align="right"
            header-align="right"
            width="130">
            <template v-slot="{row}">
              {{formatarValor(row.qtde_material_total)}}
            </template>
          </el-table-column>

          <el-table-column
            prop="valor_material"
            label="Valor MP"
            sortable  
            align="right" 
            header-align="right"
            width="130">
            <template v-slot="{row}">
              {{formatarValor(row.valor_material)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="fator"
            label="Fator MP"
            sortable  
            align="right" 
            header-align="right"
            width="130">
            <template v-slot="{row}">
              {{formatarValor(row.fator)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="valor_material_total"
            label="Total MP"
            sortable  
            align="right" 
            header-align="right"
            width="130">
            <template v-slot="{row}">
              {{formatarValor(row.valor_material_total)}}
            </template>
          </el-table-column>

          <el-table-column
            prop="grupo_cod"
            label="Grupo"
            sortable  
            width="120">
          </el-table-column>
          <el-table-column
            prop="grupo"
            label="Grupo"
            sortable  
            width="350">
          </el-table-column>
          <el-table-column
            prop="fabricante"
            label="Fabricante"
            sortable  
            width="400">
          </el-table-column>
          <el-table-column
            prop="part_number"
            label="Part Number"
            sortable  
            width="130">
          </el-table-column>

        </el-table>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-input v-if="filtro.tipo" v-model="emailDestino" id="email-enviar" placeholder="Insira o email de destino da lista de itens" style="width: 500px; margin-right: 10px;"></el-input>
        <el-button v-if="filtro.tipo" type="success" @click="enviarItensEmail" :disabled="!itensSelecionados.length || !emailDestino">Enviar Email</el-button>
        <el-button type="primary" @click="closeFormFiltrarItens">Fechar</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import { VMoney } from 'v-money'
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  directives: {
    money: VMoney   // se não registrou global
  },
  data() {
    return {
      tableKey: 0,
      loading: false,
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      divisao: {
        "negocio":{},
        "cliente":{},
        "imposto":null,
        "mao_obra":null,
        "mao_obra_total":null,
        "comissao":null,
        "markup":null,
        "margem":null,
        "itens":[],
      },
      agrupamento: {
        "itens":[]
      },
      itensOriginais: [],
      // cmv: 0,
      ibs: 0,
      cbs: 0,
      ipi: 0,
      permissao: {},
      emailDestino: 'adriano.schneider@nbrtec.com.br',
      itensSelecionados: [],
      activeTab: 'principal',
      formItemMPVisible: false,
      formFiltrarItensVisible: false,
      search: '',
      selectedRow: {},
      carregandoNegocio: false,
      carregandoDetalhe: false,
      carregandoMaoObra: false,
      carregandoImposto: false,
      carregandoComissao: false,
      carregandoDesconto: false,
      carregandoMarkup: false,
      carregandoMargem: false,
      exibirAbaGeral: false,
      exibirAbaFormacao: false,
      exibirAbaMateriaPrima: false,
      exibirAbaMaoObra: false,
      exibirAbaImposto: false,
      exibirAbaComissao: false,
      exibirAbaDesconto: false,
      exibirAbaMarkup: false,
      exibirAbaMargem: false,
      exibirAbaObservacao: false,
      filtro: {
        tipo: '',    // 'fabricante' ou 'grupo'
        valor: ''    // código selecionado
      },
      opcoesFiltro: [],       // opções carregadas do servidor
      carregandoOpcoes: false,
      dadosTabelaOriginal: [], // backup dos dados completos
      //dadosTabelaFiltrados: [], // dados exibidos na tabela      

    };
  },
  watch: {
    search() {
      this.tableKey++  // Força remontar a tabela com os dados filtrados
    }
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    // Propriedade computada que retorna os dados filtrados
    // filtrarArvore() {
    //   if (!this.search) {
    //     // return this.data.itens; // Se não houver busca, retorna todos os dados
    //     return this.divisao.itens; // Se não houver busca, retorna todos os dados
    //   }
    //   // Chama a função de filtro recursiva
    //   // return this.filtrarArvore(this.data.itens, this.search.toLowerCase());
    //   return this.filtrarArvore(this.divisao.itens, this.search.toLowerCase());
    // },
    // dadosTabela() {
    //   return this.search ? this.filtrarArvore : this.divisao.itens
    // },


    // dadosTabela() {
    //   if (!this.search) return this.divisao.itens || []
    //   return this.filtrarArvore(this.divisao.itens || [], this.search.toLowerCase())
    // },

    itensFiltrados() {
      if (!this.filtro.valor) return this.itensOriginais;

      return this.itensOriginais.filter(item => {
        if (this.filtro.tipo === 'fabricante') {
          return item.fabricante_cod == this.filtro.valor;
        }
        if (this.filtro.tipo === 'grupo') {
          return item.grupo_cod == this.filtro.valor;
        }
        return true;
      });
    },

    dadosTabela() {
      if (!this.divisao.itens) return [];
      if (!this.search) return this.divisao.itens;
      return this.filtrarArvore(this.divisao.itens, this.search.toLowerCase());
    },

    dadosFiltrados() {
      if (!this.search) {
        return this.divisao.itens
      }
      return this.filtrarArvore(this.divisao.itens, this.search.toLowerCase())
    },
    // tableKey() {
    //   return this.search ? 'filtered' : 'original'
    //   // ou melhor ainda:
    //   // return Date.now() + this.search
    // },

    labelSegundoSelect() {
      if (!this.filtro.tipo) return 'Selecione';
      return this.filtro.tipo === 'fabricante' ? 'Fabricante' : 'Grupo';
    },

    placeholderSegundoSelect() {
      if (!this.filtro.tipo) return 'Primeiro selecione o tipo de filtro';
      return this.filtro.tipo === 'fabricante' 
        ? 'Selecione um fabricante' 
        : 'Selecione um grupo';
    },

    // Se você já tem dadosTabela, use isso para evitar duplicar
    dadosTabelaFiltrados() {
      // Se não houver filtro ativo, retorna todos
      
      if (!this.filtro.tipo || !this.filtro.valor) {
        return this.dadosTabelaOriginal;
      }

      // Filtra recursivamente na árvore
      const filtrarArvore = (itens) => {
        return itens
          .map(item => {
            let novoItem = { ...item };
            if (novoItem.filhos && novoItem.filhos.length > 0) {
              novoItem.filhos = filtrarArvore(novoItem.filhos);
            }

            // Verifica se o item tem o código do fabricante/grupo
            const campo = this.filtro.tipo === 'fabricante' ? 'cod_fabricante' : 'cod_grupo';
            if (novoItem[campo] === this.filtro.valor) {
              return novoItem;
            }

            // Mantém o pai se tiver filhos que atendem ao filtro
            if (novoItem.filhos && novoItem.filhos.length > 0) {
              return novoItem;
            }

            return null;
          })
          .filter(item => item !== null);
      };

      return filtrarArvore(this.dadosTabelaOriginal);
    },

    cmv() {
      if (!this.divisao?.negocio) return 0;
      return (
        Number(this.divisao.negocio.total_mp || 0) +
        Number(this.divisao.negocio.total_mo || 0) +
        Number(this.divisao.negocio.total_mo_2 || 0) +
        // Number(this.divisao.negocio.valor_frete || 0) +
        // Number(this.divisao.negocio.valor_despesas || 0) +
        Number(this.divisao.negocio.valor_outros || 0)
      );
    }

  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_painel) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.exibirAba();
    this.negocioRevisaoDivisaoGeralCarregar();
    //this.aplicarFormatoFinal({ target: this.$el.querySelector('input') });

  },
  methods: {
    exibirAba() {
      // console.log('Permissões: ', this.permissao);
      this.exibirAbaGeral        = this.permissao.ler_painel;
      this.exibirAbaObservacao   = this.permissao.ler_painel;
      this.exibirAbaFormacao     = this.permissao.formacao_painel;
      this.exibirAbaMateriaPrima = this.permissao.materiaprima_painel;
      this.exibirAbaMaoObra      = this.permissao.maoobra_painel;
      this.exibirAbaImposto      = this.permissao.imposto_painel;
      this.exibirAbaComissao     = this.permissao.comissao_painel;
      this.exibirAbaDesconto     = this.permissao.descontorepresentante_painel || this.permissao.descontoadministrador_painel ;
      this.exibirAbaMarkup       = this.permissao.markup_painel;
      this.exibirAbaMargem       = this.permissao.margem_painel;
    },
    async negocioRevisaoDivisaoGeralCarregar() {

      // console.log("Carregar divisão de negócio geral");
      // this.divisao.geral = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.negocio = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/geral/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Geral:", response.data);
          this.divisao.negocio = response.data.negocio;
          this.divisao.cliente = response.data.cliente;
          this.divisao.mao_obra = response.data.mao_obra;
          this.divisao.mao_obra_total = response.data.mao_obra_total;

          // this.cmv = this.divisao.negocio.total_mp + 
          //            this.divisao.negocio.total_mo + 
          //            this.divisao.negocio.total_mo_2 + 
          //            this.divisao.negocio.valor_frete + 
          //            this.divisao.negocio.valor_despesas + 
          //            this.divisao.negocio.valor_outros;
          this.ibs = this.divisao.negocio.valor_total_nbrtec * (this.divisao.negocio.ibs / 100);
          this.cbs = this.divisao.negocio.valor_total_nbrtec * (this.divisao.negocio.cbs / 100);
          console.log("ipi: ", this.divisao.negocio.ipi);
          this.ipi = this.divisao.negocio.valor_total_nbrtec * (this.divisao.negocio.ipi / 100);
          // console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados Gerais da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #01: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }

    },

    async carregarDivisaoNegocioAgruparItens() {
      if (this.$route.params.id) {

        this.loading = true;
        const id = this.$route.params.id;

        if (!id || isNaN(id)) {
          this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
          return;
        }

        try {

          const response = await axios.get(url + "/orcamento/divisao/negocio/agrupar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Agrupamento:", response.data);
  
          this.itensOriginais = response.data.agrupamento;
          this.itensFiltrados = [...this.itensOriginais];
          // console.log('Itens Originais: ', this.itensOriginais);
          // console.log('Itens Filtrados: ', this.itensFiltrados);

          this.$notify({
            title: "Sucesso",
            message: "Dados dos Detalhes do Itens da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #02: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }
    },

    async negocioRevisaoDivisaoDetalheCarregar() {
      // implementar requisição com o JSON dos detalhes

      // console.log("Carregar detalhes da divisão de negócio");
      // this.divisao.negocio = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.itens = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/detalhe/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Detalhes:", response.data);
          //this.divisao.detalhe = response.data.detalhe;
          //this.divisao.detalhe = response.data.arvore;
          // console.log('response.data', response.data);
          this.divisao.itens = response.data.arvore;
          this.divisao.itens.atividade_total_mp_sfd = response.data.atividade_total_mp_sfd;
          this.divisao.itens.atividade_total_mp_cfd = response.data.atividade_total_mp_cfd;
          // console.log('Divisão do Negócio ITENS:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados dos Detalhes do Itens da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #02: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }

    },

    async negocioRevisaoDivisaoMaoObraCarregar() {
      // implementar requisição com o JSON da Mão de Obra

      // console.log("Carregar Mão de Obra da divisão de negócio");
      // this.divisao.negocio = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.mao_obra = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/mao_obra/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Mão de Obra:", response.data);
          this.divisao.mao_obra = response.data.mao_obra;
          this.divisao.mao_obra_total = response.data.mao_obra_total;
          // console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados da Mão de Obra da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #03: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }

    },

    async negocioRevisaoDivisaoImpostoCarregar() {
      // implementar requisição com o JSON dos impostos
      
      // console.log("Carregar detalhes da divisão de negócio");
      // this.divisao.imposto = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.imposto = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/imposto/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Impostos:", response.data);
          this.divisao.imposto = response.data.imposto;
          // console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados dos Impostos da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #04: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }
    },

    async negocioRevisaoDivisaoComissaoCarregar() {
      // implementar requisição com o JSON das comissões
      
      // console.log("Carregar comissoes da divisão de negócio");
      // this.divisao.comissao = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.comissao = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/comissao/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Comissões:", response.data);
          this.divisao.comissao = response.data.comissao;
          // console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados das Comissões da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #05: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }
    },

    async negocioRevisaoDivisaoMarkupCarregar() {
      // implementar requisição com o JSON dos markup
      
      // console.log("Carregar markup da divisão de negócio");
      // this.divisao.markup = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.markup = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/markup/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Markups:", response.data);
          this.divisao.markup = response.data.markup;
          // console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados do Markup da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #06: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }
    },

    async negocioRevisaoDivisaoMargemCarregar() {
      // implementar requisição com o JSON das margens
      
      // console.log("Carregar margens da divisão de negócio");
      // this.divisao.margem = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.margem = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/margem/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Margens:", response.data);
          this.divisao.margem = response.data.margem;
          console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados da Margem da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #07: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }
    },

    async negocioRevisaoDivisaoRecalcular() {

      if (this.$route.params.id) {

        console.log("Recalcular Negócio");

        this.loading = true;
        // this.divisao.margem = {};
        // const id = this.$route.params.id;
        const id = this.divisao.negocio.negocio_revisao_id;

        console.log("Negócio Revisão ID:", id);

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          // console.log("Enviando requisição para recalcular a revisao do negócio com ID:", id);
          const response = await axios.get(url + "/negocio/revisao/divisao/recalcular/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          // console.log("Resposta recebida do servidor:", response);

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          console.log("Divisão do Negócio Recalculada:", response.data);

          this.negocioRevisaoDivisaoGeralCarregar();
          //Verifica se deve carregar a aba de detalhes
          //if (1==1) {
            this.negocioRevisaoDivisaoDetalheCarregar();
          //} else {
          //  this.divisao.itens = {};
          //}
          //Verifica se deve carregar a aba de Mão de Obra
          //if (1==1) {
            this.negocioRevisaoDivisaoMaoObraCarregar();
          //} else {
          //  this.divisao.mao_obra = {};
          //}
          //Verifica se deve carregar a aba de impostos
          //if (1==1) {
            this.negocioRevisaoDivisaoImpostoCarregar();
          //} else {
          //  this.divisao.imposto = {};
          //}
          //Verifica se deve carregar a aba de comissões
          //if (1==1) {
            this.negocioRevisaoDivisaoComissaoCarregar();
          //} else {
          //  this.divisao.comissao = {};
          //}
          //Verifica se deve carregar a aba de markups
          //if (1==1) {
            this.negocioRevisaoDivisaoMarkupCarregar();
          //} else {
          //  this.divisao.markup = {};
          //}
          //Verifica se deve carregar a aba de margens
          //if (1==1) {
            this.negocioRevisaoDivisaoMargemCarregar();
          //} else {
          //  this.divisao.margem = {};
          //}

          this.$notify({
            title: "Sucesso",
            message: "Recalculo da Atividade da Divisão do Negócio realizado com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #07: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }

    },

    formatarData(date) {
      return date.toISOString().split('T')[0]; // '2025-11-07' 'YYYY-MM-DD'
    },

    // Função de filtro recursivo
    filtrarArvore(nodes, query) {
      if (!nodes) return [];

      return nodes.reduce((acc, node) => {
          const nodeDescription = (node.descricao || '').toLowerCase();
          let matches = nodeDescription.includes(query);

          // Filtra recursivamente os filhos
          const filhosFiltrados = this.filtrarArvore(node.filhos, query);

          if (filhosFiltrados.length > 0) {
          matches = true; // Se um filho corresponde, o pai também deve ser exibido
          }

          if (matches) {
          // Clona o nó para não alterar os dados originais
          const newNode = { ...node };
          // Atribui os filhos já filtrados ao novo nó
          newNode.filhos = filhosFiltrados;
          acc.push(newNode);
          }

          return acc;
      }, []);
    },

    aoClicarNaAba(tab) {
      // console.log('Tab switched to:', tab.name);
      if (tab.name === 'detalhes') {
        //Verifica se deve carregar a aba de detalhes
        //if (1==1) {
          // if (!this.divisao.detalhe && !this.carregandoDetalhe) {
          //if (!this.divisao.itens || this.divisao.itens.length === 0) {
            this.carregandoDetalhe = true;
            this.negocioRevisaoDivisaoDetalheCarregar().finally(() => {
              this.carregandoDetalhe = false;
            });
          //}
        //}
      } else if (tab.name === 'maoobra') {
        //Verifica se deve carregar a aba de Mão de Obra
        //if (1==1) {
          // if (!this.divisao.mao_obra && !this.carregandoMaoObra) {
          //if (!this.divisao.mao_obra) {
            this.carregandoMaoObra = true;
            this.negocioRevisaoDivisaoMaoObraCarregar().finally(() => {
              this.carregandoMaoObra = false;
            });
          //}
        //}
      } else if (tab.name === 'impostos') {
        //Verifica se deve carregar a aba de impostos
        //if (1==1) {
          // if (!this.divisao.imposto && !this.carregandoImposto) {
          //if (!this.divisao.imposto) {
            this.carregandoImposto = true;
            this.negocioRevisaoDivisaoImpostoCarregar().finally(() => {
              this.carregandoImposto = false;
            });
          //}
        //}
      } else if (tab.name === 'comissoes') {
        //Verifica se deve carregar a aba de comissões
        //if (1==1) {
          // if (!this.divisao.comissao && !this.carregandoComissao) {
          //if (!this.divisao.comissao) {
            this.carregandoComissao = true;
            this.negocioRevisaoDivisaoComissaoCarregar().finally(() => {
              this.carregandoComissao = false;
            });
          //}
        //}
      } else if (tab.name === 'desconto') {
        //Verifica se deve carregar a aba de descontos
        //if (1==1) {
          // if (!this.divisao.desconto && !this.carregandoDesconto) {
          //if (!this.divisao.desconto) {
            this.carregandoDesconto = true;
            this.negocioRevisaoDivisaoMargemCarregar().finally(() => {
              this.carregandoDesconto = false;
            });
          //}
        //}
      } else if (tab.name === 'markups') {
        //Verifica se deve carregar a aba de markups
        //if (1==1) {
          // if (!this.divisao.markup && !this.carregandoMarkup) {
          //if (!this.divisao.markup) {
            this.carregandoMarkup = true;
            this.negocioRevisaoDivisaoMarkupCarregar().finally(() => {
              this.carregandoMarkup = false;
            });
          //}
        //}
      } else if (tab.name === 'margens') {
        //Verifica se deve carregar a aba de margens
        //if (1==1) {
          // if (!this.divisao.margem && !this.carregandoMargem) {
          //if (!this.divisao.margem) {
            this.carregandoMargem = true;
            this.negocioRevisaoDivisaoMargemCarregar().finally(() => {
              this.carregandoMargem = false;
            });
          //}
        //}
      }
    },

    // Novo método para lidar com a ordenação personalizada
    aoMudarOrdenacao({ prop, order }) {
      if (!order) {
        return;
      }
      // this.ordenarArvore(this.data.itens, prop, order);
      this.ordenarArvore(this.divisao.itens, prop, order);
      // Força a re-renderização se necessário (geralmente o Vue cuida disso)
      this.$forceUpdate();
    },
    
    // Nova função de ordenação recursiva
    ordenarArvore(nodes, prop, order) {
      if (!nodes || nodes.length === 0) {
        return;
      }

      nodes.sort((a, b) => {
        let valA = a[prop];
        let valB = b[prop];

        // Tenta converter para número para uma classificação numérica correta
        const numA = Number(valA);
        const numB = Number(valB);
        
        // Verifica se ambos são números válidos (e não strings vazias ou nulas)
        const isNumeric = !isNaN(numA) && !isNaN(numB) && 
                          valA !== null && valB !== null && 
                          valA !== '' && valB !== '';

        let comparison = 0;
        if (isNumeric) {
          comparison = numA - numB;
        } else {
          // Classificação padrão de texto
          valA = String(valA || '');
          valB = String(valB || '');
          comparison = valA.localeCompare(valB, 'pt-BR');
        }

        // Inverte a ordem se for descendente
        return order === 'descending' ? -comparison : comparison;
      });

      // Chama a mesma função de ordenação para os filhos de cada nó
      nodes.forEach(node => {
        if (node.filhos && node.filhos.length > 0) {
          this.ordenarArvore(node.filhos, prop, order);
        }
      });
    },

    // Expande todas as linhas da árvore
    expandAll() {
      // this.toggleAllRows(this.data.itens, true);
      //this.toggleAllRows(this.divisao.itens, true);
      this.toggleAllRows(this.dadosTabela, true);
    },

    // Recolhe todas as linhas da árvore
    collapseAll() {
      // this.toggleAllRows(this.data.itens, false);
      //this.toggleAllRows(this.divisao.itens, false);
      this.toggleAllRows(this.dadosTabela, false);
    },

    // Função recursiva para expandir/recolher as linhas
    // toggleAllRows(data, expand) {
    //   data.forEach(row => {
    //     // Acessa a tabela pela referência 'treeTable' e chama o método de expansão
    //     this.$refs.treeTable.toggleRowExpansion(row, expand);
    //     if (row.filhos && row.filhos.length > 0) {
    //       // Chama a função recursivamente para os filhos
    //       this.toggleAllRows(row.filhos, expand);
    //     }
    //   });
    // },

    toggleAllRows(nodes, expand) {
      nodes.forEach(node => {
        this.$refs.treeTable.toggleRowExpansion(node, expand)
        if (node.filhos && node.filhos.length) {
          this.toggleAllRows(node.filhos, expand)
        }
      })
    },    

    showFormItemMP(row) {
      this.selectedRow = { ...row };
      this.formItemMPVisible = true;
    },

    closeFormItemMP() {
      this.formItemMPVisible = false;
      this.selectedRow = {};
    },

    showFormFiltrarItens() {
      this.formFiltrarItensVisible = true;
      this.carregarDivisaoNegocioAgruparItens();
    },

    closeFormFiltrarItens() {
      this.formFiltrarItensVisible = false;
    },

    // Salva apenas a alteração do registro autal na tabela
    async salvarFator() {
      // console.log('Negócio: ', this.divisao.negocio.negocio_numero);
      // console.log('Versão: ', this.divisao.negocio.negocio_versao);
      // console.log('Revisão: ', this.divisao.negocio.negocio_revisao);
      // console.log('Divisão: ', this.divisao.negocio.negocio_divisao);
      // console.log('Atividade: ', this.divisao.negocio.negocio_atividade);
      // console.log('Sequencia: ', this.divisao.negocio.negocio_sequencia);
      // console.log('Filho: ', this.selectedRow.filho);
      // console.log('Codigo: ', this.selectedRow.codigo);
      // console.log('negocio_revisao_id: ', this.selectedRow.negocio_revisao_id);
      // console.log('negocio_revisao_divisao_id: ', this.selectedRow.negocio_revisao_divisao_id);
      // console.log('Fator MP: ', this.selectedRow.fator_mp);
      // console.log('selectedRow: ', this.selectedRow);

      // // Encontra o item na árvore de dados e atualiza o fator
      // const atualizarFatorNaArvore = (itens) => {

      //   for (let item of itens) {
      //     if (item.filho === this.selectedRow.filho) { // ou use outra chave única se 'filho' não for única
      //       item.fator = this.selectedRow.fator;
      //       console.log('X1')
      //       return true;
      //     }
      //     if (item.filhos && item.filhos.length > 0) {
      //       console.log('X2')
      //       if (atualizarFatorNaArvore(item.filhos)) return true;
      //     }
      //   }
      //   return false;
      // };

      // atualizarFatorNaArvore(this.dadosTabela);

      // // Força re-render da tabela (opcional, mas útil em árvores)
      // this.tableKey += 1;

      // this.$message.success('Fator atualizado com sucesso!');

      const payload = {
        negocio_revisao_id: this.selectedRow.negocio_revisao_id,
        codigo: this.selectedRow.codigo,
        fator_mp: this.selectedRow.fator_mp,
      };

      try {

        this.loading = true;

        const response = await axios.post(url + '/divisao-negocio-atividade/alterar-fator-codigo', payload, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("8943");

        this.$notify({
          title: "Sucesso",
          message: "Dados dos Detalhes do Itens da Atividade da Divisão do Negócio recuperados com sucesso!",
          type: "success",
        });
        
      } catch (error) {
        console.error('Erro ao enviar email:', error);
        this.$message.error('Falha ao enviar o email. Tente novamente.');
      } finally {
        this.loading = false;
      }

      this.closeFormItemMP();
      this.negocioRevisaoDivisaoDetalheCarregar();
    },

    /**
     * Este método é chamado para cada linha da tabela.
     * Ele verifica se a propriedade 'pai' da linha é "0".
     * Se for, retorna a classe CSS 'root-row'.
     * @param {object} - Objeto contendo a linha.
     */
    setRowClassName({row}) {
      let classNames = [];
      if (row.pai === "0") {
        classNames.push('root-row');
        // Adiciona uma classe 'is-leaf' se a linha não tiver filhos
        if (!row.filhos || row.filhos.length === 0) {
          classNames.push('is-leaf');
        }
      }
      return classNames.join(' ');
    },

    formatarValor(valor, casas = 2) {

      if (!valor && valor !== 0) {
        return '-';
      }
      // Converte para número para garantir que a formatação funcione
      const valorNumerico = Number(valor);

      // Verifica se é um número válido
      if (isNaN(valorNumerico)) {
        return valor;
      }

      // Usa Intl.NumberFormat para o padrão brasileiro (ponto no milhar, vírgula para decimal)
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas
      }).format(valorNumerico);
    },

    alterarItemDivisaoNegocio(){
      this.$notify({
        title: "Informação",
        message: "Alterou dados dos Itens da Atividade da Divisão do Negócio!",
        type: "info",
      });
    },

    // Captura as linhas selecionadas na tabela
    handleSelectionChange(selection) {
      this.itensSelecionados = selection;
    },

    // Rotina para enviar os itens selecionados por email
    async enviarItensEmail() {

      if (!this.itensSelecionados.length) {
        this.$message.warning('Selecione pelo menos um item para enviar.');
        return;
      }

      if (!this.emailDestino || !this.validateEmail(this.emailDestino)) {
        this.$message.error('Insira um email válido.');
        return;
      }

      const payload = {
        email_destino: this.emailDestino,
        filtro: {
          tipo: this.filtro.tipo,     // "fabricante" ou "grupo"
          valor: this.filtro.valor    // código selecionado no segundo select
        },
        itens: this.itensSelecionados.map(item => ({
          codigo: item.codigo,
          descricao: item.descricao,
          grupo_cod: item.grupo_cod,
          grupo: item.grupo,
          fabricante: item.fabricante,
          part_number: item.part_number,
          qtde_material_total: item.qtde_material_total,
          valor_material: item.valor_material,
          fator: item.fator,
          valor_mp: item.valor_mp,
          // adicione outros campos se necessário
        }))
      };

      try {

        this.loading = true;

        // console.log("123");
        // console.log("Payload para envio de email:", payload);
        const response = await axios.post(url + '/divisao-negocio/enviar-itens-email', payload, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });
        // console.log("124");

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }
        // console.log("125");

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("126");
        // console.log("Email enviado!");
        
        // Limpar após envio (opcional)
        this.emailDestino = 'adriano.schneider@nbrtec.com.br';
        this.$refs.itensAgrupadosTable.clearSelection();
        this.itensSelecionados = [];

        this.$notify({
          title: "Sucesso",
          message: "Dados dos Detalhes do Itens da Atividade da Divisão do Negócio recuperados com sucesso!",
          type: "success",
        });
        
      } catch (error) {
        console.error('Erro ao enviar email:', error);
        this.$message.error('Falha ao enviar o email. Tente novamente.');
      } finally {
        this.loading = false;
      }

    },

    // Validação simples de email
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },

    async negocioRevisaoDivisaoPrincipalAlterar() {

      // Validação básica
      if (!this.divisao.negocio) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'Dados do negócio não carregados.',
        });
        return;
      }

      // Validação Valor Total da Materia Prima
      if (this.divisao.negocio.total_mp < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor Total da Matéria Prima deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor Total da Mão de Obra
      if (this.divisao.negocio.total_mo < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor Total da Mão de Obra deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor Total da Mão de Obra
      if (this.divisao.negocio.perc_mo_2 < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Percentual da Mão de Obra 2 deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor Total da Mão de Obra
      if (this.divisao.negocio.total_mo_2 < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor Total da Mão de Obra 2 deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor Frete
      if (this.divisao.negocio.valor_frete < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor Frete deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor das Despesas
      if (this.divisao.negocio.valor_despesas < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor das Despesas deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor Outros
      if (this.divisao.negocio.valor_outros < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor outros deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Faturamento Direto
      if (this.divisao.negocio.valor_faturamento_direto < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor Faturamento Direto deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      try {

        this.loading = true;

        console.log("Dados atuais do negócio:", this.divisao.negocio);
        
        const dados = {
          negocio_id: this.divisao.negocio.id,
          negocio_revisao_id: this.divisao.negocio.negocio_revisao_id,
          total_mp: this.divisao.negocio.total_mp,
          total_mo: this.divisao.negocio.total_mo,
          perc_mo_2: this.divisao.negocio.perc_mo_2,
          total_mo_2: this.divisao.negocio.total_mo_2,
          valor_frete: this.divisao.negocio.valor_frete,
          valor_despesas: this.divisao.negocio.valor_despesas,
          valor_outros: this.divisao.negocio.valor_outros,
          margem_faturamento_direto: this.divisao.negocio.margem_faturamento_direto,
          valor_faturamento_direto: this.divisao.negocio.valor_faturamento_direto,
          observacao_interna: this.divisao.negocio.observacao_interna,
          
        };

        // console.log("Dados a serem alterados:", dados);      

        // console.log("Foi!");

        const response = await axios.post(url + "/negocio/revisao/divisao/principal/alterar/",dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log("Voltou (1)!");

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("Voltou (2)!");

        this.negocioRevisaoDivisaoRecalcular();

        this.$notify({
          title: "Sucesso",
          message: "Principal da Atividade da Divisão do Negócio ajustados com sucesso!",
          type: "success",
        });

      } catch (error) {
        this.$notify({
          title: "Erro",
          message: error.response?.data?.message || "Falha ao salvar o principal.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    async negocioRevisaoDivisaoMaoObraAlterar() {

      try {

        this.loading = true;

        const payload = {
          negocio_divisao_id: this.divisao.negocio.id,
          mao_obra: this.divisao.mao_obra.map(item => ({
            id: parseInt(item.codigo),
            qtde_hora: Number(item.qtde_hora),
            valor_hora: Number(item.valor_hora)
          }))
        };

        // console.log("Dados a serem alterados:", payload);      

        const response = await axios.post(url + "/negocio/revisao/divisao/mao-obra/alterar/",payload, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log('Sucesso!', response.data);

        // console.log("Voltou (1)!");

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("Voltou (2)!");

        this.negocioRevisaoDivisaoRecalcular();

        this.$notify({
          title: "Sucesso",
          message: "Mão de Obra da Atividade da Divisão do Negócio ajustada com sucesso!",
          type: "success",
        });

      } catch (error) {
        console.error('Erro ao enviar dados:', error);
        this.$notify({
          title: "Erro",
          message: error.response?.data?.message || "Falha ao salvar a mão de obra.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }

      // // Validação básica
      // if (!this.divisao.negocio) {
      //   this.$notify.warning({
      //     title: 'Atenção',
      //     message: 'Dados do negócio não carregados.',
      //   });
      //   return;
      // }

      // // Validação Valor Outros
      // if (this.divisao.negocio.valor_outros >= 0) {
      //   this.$notify.warning({
      //     title: 'Atenção',
      //     message: 'O campo Valor outros deve ser preenchido com um valor zerado ou maior.',
      //   });
      //   return;
      // }

      // // Validação Faturamento Direto
      // if (this.divisao.negocio.valor_faturamento_direto >= 0) {
      //   this.$notify.warning({
      //     title: 'Atenção',
      //     message: 'O campo Valor Faturamento Direto deve ser preenchido com um valor zerado ou maior.',
      //   });
      //   return;
      // }

      // try {

      //   this.loading = true;

      //   const dados = {
      //     negocio_id: this.divisao.negocio.id,
      //     valor_outros: this.divisao.negocio.valor_outros,
      //     valor_faturamento_direto: this.divisao.negocio.valor_faturamento_direto,
      //   };

      //   console.log("Dados a serem alterados:", dados);      

      //   console.log("Foi!");

      //   const response = await axios.post(url + "/negocio/revisao/divisao/principal/alterar/",dados, {
      //     headers: {
      //       Authorization: "Bearer " + this.$store.state.token,
      //     }
      //   });

      //   console.log("Voltou (1)!");

      //   if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
      //     this.$store.dispatch("logout").then(() => {
      //       this.$router.push("/login");
      //     });
      //   }

      //   if (response.status === 401) {
      //     await this.$store.dispatch("logout");
      //     this.$router.push("/login");
      //     return;
      //   }

      //   console.log("Voltou (2)!");

      //   this.negocioRevisaoDivisaoRecalcular();

      //   this.$notify({
      //     title: "Sucesso",
      //     message: "Impostos da Atividade da Divisão do Negócio ajustados com sucesso!",
      //     type: "success",
      //   });

      // } catch (error) {
      //   this.$notify({
      //     title: "Erro",
      //     message: error.response?.data?.message || "Falha ao salvar os impostos.",
      //     type: "error",
      //   });
      // } finally {
      //   this.loading = false;
      // }
    },

    async negocioRevisaoDivisaoImpostoAlterar() {

      // // Validação básica
      // if (!this.divisao.imposto) {
      //   this.$notify.warning({
      //     title: 'Atenção',
      //     message: 'Dados de imposto não carregados.',
      //   });
      //   return;
      // }

      // // Validação do NCM (obrigatório)
      // const ncm = this.divisao.imposto.ncm_numero?.toString().trim();
      // if (!ncm) {
      //   this.$notify.warning({
      //     title: 'Atenção',
      //     message: 'O campo NCM é obrigatório.',
      //   });
      //   return;
      // }

      // try {

      //   this.loading = true;

      //   const dados = {
      //     negocio_id: this.divisao.negocio.id,
      //     ncm_numero: ncm,
      //   };

      //   // console.log("Dados a serem alterados:", dados);      

      //   // console.log("Foi!");

      //   const response = await axios.post(url + "/negocio/revisao/divisao/imposto/alterar/",dados, {
      //     headers: {
      //       Authorization: "Bearer " + this.$store.state.token,
      //     }
      //   });

      //   // console.log("Voltou (1)!");

      //   if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
      //     this.$store.dispatch("logout").then(() => {
      //       this.$router.push("/login");
      //     });
      //   }

      //   if (response.status === 401) {
      //     await this.$store.dispatch("logout");
      //     this.$router.push("/login");
      //     return;
      //   }

      //   // console.log("Resposta: ", response.data);
      //   // console.log("Voltou (2)!");

      //   // this.negocioRevisaoDivisaoDetalheCarregar();
      //   this.negocioRevisaoDivisaoRecalcular();

      //   this.$notify({
      //     title: "Sucesso",
      //     message: "Impostos da Atividade da Divisão do Negócio ajustados com sucesso!",
      //     type: "success",
      //   });

      // } catch (error) {
      //   this.$notify({
      //     title: "Erro",
      //     message: error.response?.data?.message || "Falha ao salvar os impostos.",
      //     type: "error",
      //   });
      // } finally {
      //   this.loading = false;
      // }
    },

    async negocioRevisaoDivisaoComissaoAlterar() {

      // Validação básica
      if (!this.divisao.comissao) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'Dados das Comissões do negócio não foram carregados.',
        });
        return;
      }

      // Validação Percentual Comissão Gerente
      if (this.divisao.comissao.comissao_gerente_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Comissão do Gerente deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Comissão Interna
      if (this.divisao.comissao.comissao_interna_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Comissão Interna deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Comissão Externa
      if (this.divisao.comissao.comissao_externa_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Comissão Externa deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Indicador Externo
      if (this.divisao.comissao.indicador_externo_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual do Indicador Externo deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Fator Comissão Gerente
      if (this.divisao.comissao.fator_comissao_gerente < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do fator de Comissão do Gerente deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Fator Comissão Interna
      if (this.divisao.comissao.fator_comissao_interna < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do fator de Comissão Interna deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Fator Comissão Externa
      if (this.divisao.comissao.fator_comissao_externa < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do fator de Comissão Externa deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Fator Indicador Externo
      if (this.divisao.comissao.fator_indicador_externo < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do fator do Indicador Externo deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      try {

        this.loading = true;

        // console.log('divisao.cliente.cliente_cod', this.divisao.cliente.cliente_cod);
        // console.log('divisao.comissao', this.divisao.comissao);
        
        const dados = {
          negocio_id: this.divisao.negocio.id,
          negocio_revisao_id: this.divisao.comissao.negocio_revisao_id,
          fabricante_id: this.divisao.cliente.cliente_cod,
          comissao_gerente_percentual: Number(this.divisao.comissao.comissao_gerente_percentual),
          comissao_interna_percentual: Number(this.divisao.comissao.comissao_interna_percentual),
          comissao_externa_percentual: Number(this.divisao.comissao.comissao_externa_percentual),
          indicador_externo_percentual: Number(this.divisao.comissao.indicador_externo_percentual),
          fator_comissao_gerente: Number(this.divisao.comissao.fator_comissao_gerente),
          fator_comissao_interna: Number(this.divisao.comissao.fator_comissao_interna),
          fator_comissao_externa: Number(this.divisao.comissao.fator_comissao_externa),
          fator_indicador_externo: Number(this.divisao.comissao.fator_indicador_externo),
        };

        // console.log("Dados a serem alterados:", dados);      

        // console.log("Foi!");

        const response = await axios.post(url + "/negocio/revisao/divisao/comissao/alterar/",dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log("Voltou (1)!");

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("Voltou (2)!");

        this.negocioRevisaoDivisaoRecalcular();

        this.$notify({
          title: "Sucesso",
          message: "Comissões da Atividade da Divisão do Negócio ajustados com sucesso!",
          type: "success",
        });

      } catch (error) {
        this.$notify({
          title: "Erro",
          message: error.response?.data?.message || "Falha ao salvar as comissões.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    async negocioRevisaoDivisaoMarkupAlterar() {

      // Validação básica
      if (!this.divisao.markup) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'Dados de Markup do negócio não foram carregados.',
        });
        return;
      }

      // Validação Percentual Markup Despesas Administrativas
      if (this.divisao.markup.despesas_administrativas_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Markup das Despesas Administrativas deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Markup Custo Indireto
      if (this.divisao.markup.custo_indireto_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Markup de Custo Indireto deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Markup Gastos Gerais Fabricação
      if (this.divisao.markup.gastos_gerais_fabricacao_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Markup de Gastos Gerais de Fabricação deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Markup Gastos Gerais Fabricação
      if (this.divisao.markup.margem_faturamento_direto < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Markup de Faturamento Direto deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      try {

        this.loading = true;

        console.log('divisao.markup', this.divisao.markup);

        const dados = {
          negocio_id: this.divisao.negocio.id,
          negocio_revisao_id: this.divisao.markup.negocio_revisao_id,
          despesas_administrativas_percentual: Number(this.divisao.markup.despesas_administrativas_percentual),
          custo_indireto_percentual: Number(this.divisao.markup.custo_indireto_percentual),
          gastos_gerais_fabricacao_percentual: Number(this.divisao.markup.gastos_gerais_fabricacao_percentual),
          margem_faturamento_direto: Number(this.divisao.markup.margem_faturamento_direto),
        };

        // console.log("Dados a serem alterados:", dados);      

        const response = await axios.post(url + "/negocio/revisao/divisao/markup/alterar/",dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        this.negocioRevisaoDivisaoRecalcular();

        this.$notify({
          title: "Sucesso",
          message: "Markup da Atividade da Divisão do Negócio ajustados com sucesso!",
          type: "success",
        });

      } catch (error) {
        this.$notify({
          title: "Erro",
          message: error.response?.data?.message || "Falha ao salvar os Markups.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    async negocioRevisaoDivisaoMargemAlterar() {

      // Validação básica
      if (!this.divisao.margem) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'Dados da Margens do negócio não foram carregados.',
        });
        return;
      }

      // Validação Percentual Markup Despesas Administrativas
      if (this.divisao.margem.lucro_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual da Margem de Lucro deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }
      if (this.divisao.margem.lucro_fator < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do fator da Margem de Lucro deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }
      if (this.divisao.margem.desconto_representante_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual do Desconto do Representante_percentual deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }
      if (this.divisao.margem.desconto_administrador_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual do Desconto do Administrador deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      try {

        this.loading = true;

        console.log('divisao.margem', this.divisao.margem);

        const dados = {
          negocio_id: this.divisao.negocio.id,
          negocio_revisao_id: this.divisao.margem.negocio_revisao_id,
          fabricante_id: this.divisao.cliente.cliente_cod,
          lucro_percentual: Number(this.divisao.margem.lucro_percentual),
          lucro_fator: Number(this.divisao.margem.lucro_fator),
          desconto_representante_percentual: Number(this.divisao.margem.desconto_representante_percentual),
          desconto_administrador_percentual: Number(this.divisao.margem.desconto_administrador_percentual),
        };

        // console.log("Dados a serem alterados:", dados);      

        // console.log("Foi!");

        const response = await axios.post(url + "/negocio/revisao/divisao/margem/alterar/",dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log("Voltou (1)!");

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("Voltou (2)!");

        this.negocioRevisaoDivisaoRecalcular();

        this.$notify({
          title: "Sucesso",
          message: "Margens da Atividade da Divisão do Negócio ajustados com sucesso!",
          type: "success",
        });

      } catch (error) {
        this.$notify({
          title: "Erro",
          message: error.response?.data?.message || "Falha ao salvar as Margens.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    // formatarInput(e) {
    //   let valor = e.target.value.replace(/[^\d,]/g, '')
    //   valor = valor.replace(',', '.')
    //   const num = parseFloat(valor)
    //   if (!isNaN(num)) {
    //     this.divisao.comissao.comissao_gerente_percentual = num
    //   }
    // },
    // aplicarFormatoFinal(e) {
    //   // Quando sair do campo, força o formato bonito
    //   const v = this.divisao.comissao.comissao_gerente_percentual
    //   e.target.value = v != null ? Number(v).toFixed(2).replace('.', ',') + '%' : '0,00%'
    // },

    async enviarCotacao() {

      // console.log("Carregar divisão de negócio geral");
      // // this.divisao.geral = {"x":1, "y":2};

      // //if (this.$route.params.id) {
      // if (1==1) {

      //   this.loading = true;
      //   // this.divisao.negocio = {};
      //   // const id = this.$route.params.id;

      //   try {

      //     // if (!id || isNaN(id)) {
      //     //   this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
      //     //   return;
      //     // }

      //     const id = 584;
      //     const response = await axios.get(url + "/enviar-cotacao-2/" + id, {
      //       headers: {
      //         Authorization: "Bearer " + this.$store.state.token,
      //       }
      //     });

      //     if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
      //       this.$store.dispatch("logout").then(() => {
      //         this.$router.push("/login");
      //       });
      //     }

      //     if (response.status === 401) {
      //       await this.$store.dispatch("logout");
      //       this.$router.push("/login");
      //       return;
      //     }

      //     console.log('Enviado Email');

      //     this.$notify({
      //       title: "Sucesso",
      //       message: "Dados Gerais da Atividade da Divisão do Negócio recuperados com sucesso!",
      //       type: "success",
      //     });

      //   } catch (error) {
      //     this.$notify({
      //       title: "Erro",
      //       message: `Falha ao realizar a pesquisa #01: ${error.message}`,
      //       type: "error",
      //     });
      //   } finally {
      //     this.loading = false;
      //   }

      // }

    },

    // async pesquisaX235() {
    //   try {

    //     this.loading = true;
    //     this.negocios = [];
    //     this.negociosSGE = [];

    //     const negocioId = this.formPesquisaNegocio.negocio;
    //     if (!negocioId || isNaN(negocioId)) {
    //       this.$notify.warning({ title: 'Atenção', message: 'Digite um número de negócio válido.' });
    //       return;
    //     }

    //     this.formPesquisaNegocio.negocio = null;

    //     const response = await axios.get(url + "/negocio-orcamento/"+negocioId, {
    //       headers: {
    //         Authorization: "Bearer " + this.$store.state.token,
    //       }
    //     });
    //     if (response.status === 401) {
    //       await this.$store.dispatch("logout");
    //       this.$router.push("/login");
    //       return;
    //     }
    //     if (!Array.isArray(response.data) && typeof response.data !== "object") {
    //       throw new Error("Dados recebidos não estão no formato esperado");
    //     }
    //     //console.log("API X124:", response.data);
    //     this.negocios = response.data;
    //     this.$notify({
    //       title: "Sucesso",
    //       message: "Pesquisa realizada com sucesso!",
    //       type: "success",
    //     });
    //   } catch (error) {
    //     this.$notify({
    //       title: "Erro",
    //       message: `Falha ao realizar a pesquisa: ${error.message}`,
    //       type: "error",
    //     });
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // async negocioCriarRevisaoXXX(row) {

    //   try {

    //     this.loading = true

    //     const dados = {
    //       negocio_numero: this.negocios.negocio_numero,
    //       negocio_versao: row.negocio_versao,
    //     };

    //     console.log("Dados enviados:", dados);      

    //     const response = await axios.post(url+"/negocio-criar-revisao/", dados, {
    //       headers: { Authorization: "Bearer " + this.$store.state.token },
    //     });
    //     if (response.data.status === "Token is Expired") {
    //       await this.$store.dispatch("logout");
    //       this.$router.push("/login");
    //     } else {
    //       this.tabelaEditaveis = [];
    //     }
    //     //this.$notify({ title: "Sucesso", message: "Produtos atualizados com sucesso!", type: "success" });

    //   } catch (error) {
    //     this.$notify({
    //       title: "Erro",
    //       message: "Não foi possível atualizar o produto.",
    //       type: "error"
    //     });
    //   } finally {
    //     this.loading = false;
    //   }

    //   this.formPesquisaNegocio.negocio = this.negocios.negocio_numero;
    //   this.pesquisaX235();

    //   // // Monta os parâmetros
    //   // const dados = {
    //   //   negocio_numero: this.negocios.negocio_numero,
    //   //   negocio_versao: row.negocio_versao
    //   // };

    //   // // Navega para a rota com parâmetros
    //   // this.$router.push({
    //   //   path: '/detalhes-negocio',
    //   //   dados: dados
    //   // });


    // },

    // Quando muda o tipo de filtro (Fabricante ou Grupo)
    aoMudarTipoFiltro() {
      this.filtro.valor = '';
      this.opcoesFiltro = [];
      
      if (!this.filtro.tipo) {
        this.aplicarFiltro(); // limpa filtro se tirar o tipo
        return;
      }

      this.carregarOpcoesFiltro();
    },

    // Busca as opções no backend Laravel
    async carregarOpcoesFiltro() {
      this.carregandoOpcoes = true;
      this.opcoesFiltro = [];

      // console.log("Carregar opções de filtro para tipo:", this.filtro.tipo);

      try {

        const id = this.$route.params.id;

        if (!id || isNaN(id)) {
          this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
          return;
        }

        // console.log("id: " + id);
        
        const endpoint = this.filtro.tipo === 'fabricante' 
          ? `/orcamento/divisao/negocio/lista-fabricantes/${id}` 
          : `/orcamento/divisao/negocio/lista-grupos/${id}`;

          // console.log("2")
        // console.log("URL completa:", url + endpoint);

        const response = await axios.get(url + endpoint, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log("DADOS RECEBIDOS:", response.data);

        this.opcoesFiltro = response.data.map(item => ({
          codigo: item.CODIGO,
          nome: this.filtro.tipo === 'fabricante' ? item.FABRICANTE : item.GRUPO
        }));
      } catch (error) {
        this.$message.error('Erro ao carregar opções de filtro');
        console.error(error);
      } finally {
        this.carregandoOpcoes = false;
      }
    },

    // Aplica o filtro na tabela
    aplicarFiltro() {
    //   console.log("Aplicar filtro:", this.filtro);

    //   if (!this.filtro.valor) {
    //     // sem filtro → restaura lista original
    //     this.agrupamento.items = [...this.itensOriginais];
    //     return;
    //   }

    //   this.agrupamento.items = this.itensOriginais.filter(item => {
    //     if (this.filtro.tipo === 'fabricante') {
    //       return item.fabricante_cod == this.filtro.valor;
    //     }

    //     if (this.filtro.tipo === 'grupo') {
    //       return item.grupo_cod == this.filtro.valor;
    //     }

    //     return true;
    //   });
    },

    // Limpa todos os filtros
    limparFiltro() {
      this.filtro.tipo = '';
      this.filtro.valor = '';
      this.opcoesFiltro = [];
      this.aplicarFiltro();
    },

    // Chame isso uma vez quando carregar os dados iniciais
    inicializarDadosTabela() {
      // Supondo que você carregue this.dadosTabela em algum momento
      this.dadosTabelaOriginal = JSON.parse(JSON.stringify(this.dadosTabela)); // deep copy
      this.dadosTabelaFiltrados = this.dadosTabelaOriginal;
    }

  },
};
</script>
<style>
  .el-table {
    box-sizing: border-box;
  }
  .el-table th,
  .el-table td {
    display: table-cell !important;
    text-align: left;
    padding: 10px;
  }
  .el-table__header,
  .el-table__body {
    width: 100%;
    table-layout: fixed;
  }
  .el-table .el-table__cell {
    padding: 0;
  }
  .details-icon-button.el-button--mini {
    padding: 5px;
  }
  .item {
    margin:0;
  }
  .main-table .el-table__body-wrapper /deep/.el-table__row /deep/.el-table__cell {
    background-color: #f0f9eb !important;
  }
  .second-table .el-table__body-wrapper /deep/.el-table__row /deep/.el-table__cell {
    background-color: white !important;
  }

  .el-row-topo {
    margin-top: 10px;
  }

  .el-table .root-row {
    font-weight: bold;
    background-color: #f0f9eb; /* Um fundo verde claro para destacar mais */
  }

/* Adiciona um ícone de "documento" antes do texto na primeira coluna
  apenas para as linhas que são "folhas" (classe 'is-leaf').
  Isso alinha visualmente o conteúdo de todas as linhas.
*/  

  .el-table .is-leaf .tree-column-codigo .cell::before {
    content: "\e722"; /* Código para o 'el-icon-document' */
    font-family: 'element-icons';
    color: #c0c4cc;
    font-size: 12px;
    
    /* Espaçamento para simular o ícone de expandir/recolher */
    display: inline-block;
    width: 24px;
    text-align: center;
    vertical-align: middle;
  }

  /* Estilo para a div que contém os botões e o filtro */
  .table-controls {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  /* Estilo para o campo de filtro */
  .filter-input {
    width: 400px;
    margin-right: 10px;
  }

  /* Novo estilo para deixar o botão de detalhes menor */
  .details-icon-button.el-button--mini {
    padding: 5px; /* Reduz o preenchimento ao redor do ícone */
  }

  /* Estilos para o conteúdo da janela de detalhes */
  .details-content p {
    margin: 10px 0;
    font-size: 16px;
    line-height:0.8
  }

  .details-content p strong {
    display: inline-block;
    width: 120px;     
  }

  .el-table .el-table__cell {
    padding: 0;
  }
  .alinha-direita {
    text-align: right !important;
    padding-left: 20px !important;
  }
  .qtde-horas {
    width: 60px !important;
    text-align: right !important;
  }
  .valor-hora {
    width: 60px !important;
    text-align: right !important;
  }
  .outros {
    width: 115px !important;
    text-align: right !important;
  }
  .fator {
    width: 50px !important;
    text-align: right !important;
  }
  .percentual {
    width: 50px !important;
    text-align: right !important;
  }
  .input-disabled .el-input__inner,
  .input-disabled .el-textarea__inner {
    background-color: #fafafa !important;
    color: #585858 !important;
    cursor: text !important;
  }
  .direita .el-input__inner{
    text-align: right !important;
  }
</style>
